module.exports = __webpack_public_path__ + "img/icons-documentos.aff786ca.svg";